"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
const useStyles = props => {
  const {
    fontFamily
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const ccListStyle = (0, _react.useMemo)(() => {
    const ccList = (0, _css.css)({
      fontFamily: fontFamily,
      listStyle: 'none',
      padding: 0,
      margin: 0
    });
    return ccList;
  }, [fontFamily]);
  return {
    'cc-List': ccListStyle
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;